import React from "react";
import {ComponentPropsFromRoute} from "../../routers/routers";
import {RouteTabs} from "../common/route-tabs/route.tabs";

export const CalendarHome: React.FC<ComponentPropsFromRoute> = ({routeChildren, name}) => {
    return (
        <RouteTabs routes={routeChildren!} />
    )
}